var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-1",attrs:{"label":"","x-small":"","color":_vm.chipColor,"text-color":"white"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('statusChanged')}}},[_vm._v(" "+_vm._s(_vm.chipText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }